import { LessonAttendance } from '@/plugins/api'
import { Lesson } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    attendances: [],
    statsAttendance: [],
    totalCount: 0,
    classLessons: [],
    page: 1,
    itemPerPage: 10,
    searchQuery: {},
    loading: false,
  },
  getters: {
    getAttendances: (state) => state.attendances,
  },
  actions: {
    async fetchAttendances({ commit }, params) {
      const res = await LessonAttendance.fetch(params)
      commit('setLessonAttendance', res)
      return res
    },
    async findStatsAttendance({ commit }, params) {
      const res = await LessonAttendance.findStatsAttendance(params)
      commit('setStatsAttendance', res)
      return res
    },
    async countAttendances({ commit }, params) {
      const res = await LessonAttendance.count(params)
      commit('setCountAttendance', res)
      return res
    },
    async updateAttendances(_, { id, data }) {
      await Lesson.updateAttendance(id, { ...data })
    },
    async update(_, { id, ...data }) {
      await LessonAttendance.update(id, data)
    },
    async findTimeTable({ commit }, data) {
      const res = await Lesson.findTimeTable({ ...data })
      commit('setClassLessons', res)
      return res
    },
    fetchAttendancesIndependent(_, params) {
      return LessonAttendance.fetch(params)
    },
  },
  mutations: {
    setLessonAttendance(state, data) {
      state.attendances = data
    },
    setStatsAttendance(state, data) {
      state.statsAttendance = data
    },
    setCountAttendance(state, data) {
      state.totalCount = data
    },
    setClassLessons(state, payload) {
      state.classLessons = payload
    },
    setFiltered(state, payload) {
      state.filtered = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setItemPerPage(state, payload) {
      state.itemPerPage = payload
    },
    setSearchQuery(state, data) {
      state.searchQuery = data
    },
  },
}
